module.exports = __webpack_public_path__ + "static/img/resume-side-bar-rtl.3184eb3.png";